var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZendesk({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 -30.5 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.25 51.233v142.773H0L118.25 51.233zm0-51.233c0 32.644-26.481 59.125-59.125 59.125S0 32.645 0 0h118.25zm19.5 194.006c0-32.677 26.449-59.125 59.125-59.125 32.677 0 59.125 26.48 59.125 59.125H137.75zm0-51.266V0H256L137.75 142.74z",
    fill: "#03363D"
  })));
}

export default SvgZendesk;